(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(function() {
  function validateRequired(container) {
    var valid = true;
    container.querySelectorAll('[required]').forEach(function(inp) {
      var ok = inp.value.trim() && inp.checkValidity();
      inp.classList.toggle('is-invalid', !ok);
      if (!ok) valid = false;
    });
    return valid;
  }

  function init() {
    document.querySelectorAll('.contact-form').forEach(function(section) {
      var form = section.querySelector('form');
      if (!form) return;

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        if (!validateRequired(form)) return;

        var successEl = section.querySelector('[data-contact-form-success]');
        var errorEl = section.querySelector('[data-contact-form-error]');
        errorEl.hidden = true;
        successEl.hidden = false;
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

        form.target = 'contact-form-sink';
        form.submit();
        setTimeout(function() { form.reset(); form.target = ''; }, 500);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-a-rep"] && !Shopify.designMode) return;
  try {
    
(function() {
  var IFRAME = 'find-a-rep-sink';

  function resolveZip(zip, data) {
    var z = String(zip).padStart(5, '0');
    var split = data.split_zips[z];
    if (split) {
      var m = data.regions.find(function(r) { return r.state_code === split.state_code && r.split === split.split; });
      if (m) return m;
    }
    var sc = (data.zip_prefixes || {})[z.substring(0, 3)];
    if (!sc) return null;
    var cands = data.regions.filter(function(r) { return r.state_code === sc; });
    if (!cands.length) {
      cands = data.regions.filter(function(r) { return r.state_code.indexOf(sc) === 0; });
    }
    return cands.find(function(r) { return !r.split; }) || cands[0] || null;
  }

  function stateName(zip, data) {
    var region = resolveZip(zip, data);
    if (region) return region.state_name;
    var sc = (data.zip_prefixes || {})[String(zip).padStart(5, '0').substring(0, 3)];
    return sc || null;
  }

  var HEADSHOTS = {};
  var headshotScript = document.querySelector('[data-rep-headshots]');
  if (headshotScript) { try { HEADSHOTS = JSON.parse(headshotScript.textContent); } catch(e) {} }

  function fillRepCard(section, prefix, rep, isOpen) {
    var card = section.querySelector('[data-find-rep-' + prefix + ']');
    if (!rep) { card.hidden = true; return; }
    card.hidden = false;
    var isRegional = prefix === 'regional';
    section.querySelector('[data-rep-' + prefix + '-name]').textContent = rep.name;
    section.querySelector('[data-rep-' + prefix + '-' + (isRegional ? 'title' : 'company') + ']').textContent = (isRegional ? rep.title : rep.company) || '';
    if (isRegional) {
      var photo = section.querySelector('[data-rep-regional-photo]');
      var url = HEADSHOTS[rep.name];
      if (photo && url) {
        photo.src = url;
        photo.alt = rep.name;
        photo.hidden = false;
      }
    }
    ['phone', 'email'].forEach(function(f) {
      var link = section.querySelector('[data-rep-' + prefix + '-' + f + ']');
      if (rep[f]) {
        link.textContent = rep[f];
        link.href = (f === 'phone' ? 'tel:' + rep[f].replace(/[^0-9+]/g, '') : 'mailto:' + rep[f]);
        link.parentNode.hidden = false;
      } else {
        link.parentNode.hidden = true;
      }
    });
  }

  function validateRequired(container) {
    var valid = true;
    container.querySelectorAll('[required]').forEach(function(inp) {
      var ok = inp.value.trim() && inp.checkValidity();
      inp.classList.toggle('is-invalid', !ok);
      if (!ok) valid = false;
    });
    return valid;
  }

  function iframeSubmit(form) {
    form.target = IFRAME;
    form.requestSubmit();
  }

  function init() {
    document.querySelectorAll('section.find-a-rep').forEach(function(section) {
      var formWrap = section.querySelector('[data-find-rep-form]');
      var resultWrap = section.querySelector('[data-find-rep-result]');
      var contactForm = formWrap && formWrap.querySelector('form');
      var errorEl = formWrap && formWrap.querySelector('[data-find-rep-error]');
      if (!contactForm) return;

      var cache = null;
      var ready = false;

      function loadData() {
        if (cache) return Promise.resolve(cache);
        var url = (section.querySelector('script[data-rep-data-url]') || {}).getAttribute && section.querySelector('script[data-rep-data-url]').getAttribute('data-rep-data-url');
        if (!url) return Promise.reject('No data URL');
        return fetch(url).then(function(r) { return r.json(); }).then(function(d) { cache = d; return d; });
      }

      contactForm.addEventListener('submit', function(e) {
        if (ready) { contactForm.target = IFRAME; return; }
        e.preventDefault();
        errorEl.hidden = true;

        if (!validateRequired(formWrap)) return;

        var vals = {};
        ['first_name', 'last_name', 'email', 'company', 'zip', 'state'].forEach(function(n) {
          vals[n] = formWrap.querySelector('[name="' + n + '"]').value.trim();
        });

        contactForm.querySelector('[data-cf="first_name"]').value = vals.first_name;
        contactForm.querySelector('[data-cf="last_name"]').value = vals.last_name;
        contactForm.querySelector('[data-cf="email"]').value = vals.email;
        contactForm.querySelector('[data-cf="state"]').value = vals.state;
        contactForm.querySelector('[data-cf="body"]').value = 'Company: ' + vals.company + '\nState: ' + vals.state + '\nZIP: ' + vals.zip;

        loadData().then(function(data) {
          var region = resolveZip(vals.zip, data);
          if (!region) {
            errorEl.hidden = false;
            errorEl.querySelector('p').textContent = 'We could not find a representative for that zip code. Please check and try again.';
            return;
          }

          section.querySelector('[data-find-rep-state]').textContent = stateName(vals.zip, data) || '';
          fillRepCard(section, 'regional', region.regional_manager, false);
          fillRepCard(section, 'local', region.local_rep, region.is_open);

          formWrap.hidden = true;
          resultWrap.hidden = false;

          var tellUs = section.closest('.shopify-section').querySelector('[data-tell-us-more]');
          if (tellUs) tellUs.hidden = false;

          ready = true;
          contactForm.requestSubmit();
        }).catch(function() {
          errorEl.hidden = false;
          errorEl.querySelector('p').textContent = 'Something went wrong. Please try again later.';
        });
      });
    });

    document.querySelectorAll('[data-tell-us-more]').forEach(function(wrapper) {
      var form = wrapper.querySelector('form');
      if (!form) return;

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        if (!validateRequired(form)) return;

        var successEl = wrapper.querySelector('[data-tell-us-more-success]');
        wrapper.querySelector('[data-tell-us-more-error]').hidden = true;
        successEl.hidden = false;
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

        form.target = IFRAME;
        form.submit();
        setTimeout(function() { form.reset(); form.target = ''; }, 500);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var burger = document.querySelector('.header__burger');
  var nav = document.getElementById('header-mobile-nav');
  var overlay = document.querySelector('.header__overlay');
  var closeBtn = document.querySelector('.header__mobile-close');

  if (!burger || !nav) return;

  function openNav() {
    nav.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    nav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    nav.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    nav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', function () {
    nav.classList.contains('is-open') ? closeNav() : openNav();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  document.querySelectorAll('.header__mobile-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var submenu = this.nextElementSibling;
      if (submenu) submenu.classList.toggle('is-open', !expanded);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-forms"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initTabs(section) {
    var tabs = section.querySelectorAll('[data-warranty-tab]');
    var panels = section.querySelectorAll('[data-warranty-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.getAttribute('data-warranty-tab');
        tabs.forEach(function(t) { t.classList.remove('warranty-forms__tab--active'); });
        tab.classList.add('warranty-forms__tab--active');
        panels.forEach(function(p) {
          p.hidden = p.getAttribute('data-warranty-panel') !== target;
        });
      });
    });
  }

  function initUploads(section) {
    var uploads = section.querySelectorAll('[data-warranty-upload]');

    uploads.forEach(function(upload) {
      var fileInput = upload.querySelector('[data-warranty-file]');
      var textEl = upload.querySelector('[data-warranty-upload-text]');
      var originalText = textEl ? textEl.textContent : '';

      upload.addEventListener('click', function(e) {
        if (e.target.closest('[data-warranty-upload-help]')) return;
        fileInput.click();
      });

      fileInput.addEventListener('change', function() {
        if (fileInput.files.length > 0) {
          textEl.textContent = fileInput.files[0].name;
        } else {
          textEl.textContent = originalText;
        }
      });

      upload.addEventListener('dragover', function(e) {
        e.preventDefault();
        upload.classList.add('warranty-forms__upload--dragover');
      });

      upload.addEventListener('dragleave', function() {
        upload.classList.remove('warranty-forms__upload--dragover');
      });

      upload.addEventListener('drop', function(e) {
        e.preventDefault();
        upload.classList.remove('warranty-forms__upload--dragover');
        if (e.dataTransfer.files.length > 0) {
          fileInput.files = e.dataTransfer.files;
          textEl.textContent = e.dataTransfer.files[0].name;
        }
      });
    });

    var helpBtns = section.querySelectorAll('[data-warranty-upload-help]');
    helpBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var tooltip = btn.nextElementSibling;
        if (tooltip) tooltip.hidden = !tooltip.hidden;
      });
    });
  }

  function initForms(section) {
    var forms = section.querySelectorAll('form[id="warranty-form"], form[id="tech-support-form"]');

    forms.forEach(function(form) {
      var readyToSubmit = false;

      form.addEventListener('submit', function(e) {
        if (readyToSubmit) return;
        e.preventDefault();

        var invalids = form.querySelectorAll(':invalid');
        if (invalids.length > 0) {
          invalids.forEach(function(el) { el.classList.add('is-invalid'); });
          invalids[0].focus();
          return;
        }

        var body = [];
        var inputs = form.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]):not([type="file"]):not([type="submit"]), select, textarea');
        inputs.forEach(function(input) {
          if (input.value) {
            var label = input.placeholder || input.name.replace('contact[', '').replace(']', '');
            body.push(label + ': ' + input.value);
          }
        });

        var checkbox = form.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          body.push('Commercial certification: Yes');
        }

        var fileInput = form.querySelector('[data-warranty-file]');
        if (fileInput && fileInput.files.length > 0) {
          body.push('Uploaded file: ' + fileInput.files[0].name);
        }

        var bodyField = form.querySelector('input[name="contact[body]"]');
        if (!bodyField) {
          bodyField = document.createElement('input');
          bodyField.type = 'hidden';
          bodyField.name = 'contact[body]';
          form.appendChild(bodyField);
        }
        bodyField.value = body.join('\n');

        readyToSubmit = true;
        form.requestSubmit();
      });
    });
  }

  function init() {
    var sections = document.querySelectorAll('.warranty-forms');
    sections.forEach(function(section) {
      initTabs(section);
      initUploads(section);
      initForms(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
